var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 4C6 2.89543 6.89543 2 8 2H16.8847C17.3875 2 17.8718 2.18937 18.2413 2.53039L21.3566 5.40606C21.7667 5.78467 22 6.31747 22 6.87566V16C22 17.1046 21.1046 18 20 18H8C6.89543 18 6 17.1046 6 16V4Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6507 11.8188C13.1955 12.2814 12.9442 12.5365 12.8961 12.5854L12.4441 13.0449C11.9829 13.515 11.1962 13.5562 10.6876 13.1369C10.1791 12.7177 10.1413 11.9967 10.6033 11.5272L12.3874 9.71125C12.8486 9.24115 13.5041 9.021 14.1438 9.6192L14.3523 9.82768",
    stroke: "currentColor",
    strokeWidth: 1.33333
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0478 8.45599C14.503 7.99334 14.7543 7.73831 14.8023 7.68941L15.2544 7.2299C15.7156 6.7598 16.5023 6.71857 17.0108 7.13785C17.5194 7.55705 17.5572 8.27807 17.0952 8.74761L15.3111 10.5635C14.8499 11.0336 14.1952 11.2694 13.5546 10.6556L13.3462 10.4471",
    stroke: "currentColor",
    strokeWidth: 1.33333
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 22H5C3.34315 22 2 20.6569 2 19V8",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.7204ab7981292a32a1852f82f2bd5245.svg";
export { ForwardRef as ReactComponent };